import script from "./barChart.vue?vue&type=script&setup=true&lang=js"
export * from "./barChart.vue?vue&type=script&setup=true&lang=js"

import "./barChart.vue?vue&type=style&index=0&id=05a8f352&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/rk-storeroom-webui_feature_1.0.1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05a8f352"]])

export default __exports__